/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box, Group, Text } from '@mantine/core';

// Components
import { SelectionCart } from '@components/molecules/SelectionCart';
import { ListProjects } from './components/ListProjects';

// Styles
import classes from './Step4.module.css';

// Store
import useStore from '@store/index';

// Utils
import { formatCurrency } from '@utils/formats';
import { getCurrencyUnit } from '@utils/currency-units';

// I18n
import { useTranslation } from 'react-i18next';
import { useOffsetCreation } from '@features/offsets/hooks/useOffsetCreation';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Step4 = () => {
	/* ********************************** Hooks ********************************* */
	const {
		offsetCreationDatas,
		offsetAdditionalProjectsSelected,
		offsetMesurabilityProjectsSelected,
	} = useStore();

	const { handleConfirmCreateOffset, isLoading } =
		useOffsetCreation();

	const { t } = useTranslation();

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Box className={classes.content}>
				<Box>
					<Box className={classes.headerSection}>
						<Box>
							{t('offsets.stepper.step2')} (
							{offsetMesurabilityProjectsSelected &&
								offsetMesurabilityProjectsSelected.length}
							)
						</Box>
					</Box>
					<ListProjects
						type="mesurability"
						selectedProjects={
							offsetMesurabilityProjectsSelected
						}
					/>
				</Box>
				<Box className={classes.headerSection}>
					<Box>
						{t('offsets.stepper.step3')} (
						{offsetAdditionalProjectsSelected &&
							offsetAdditionalProjectsSelected.length}
						)
					</Box>
					<Group>
						<Text className={classes.headerSubtitle}>
							{t('offsets.totalAdditionality')}
						</Text>
						<Text className={classes.headerTotal}>
							{offsetAdditionalProjectsSelected &&
								Array.isArray(
									offsetAdditionalProjectsSelected
								) &&
								formatCurrency(
									offsetAdditionalProjectsSelected.reduce(
										(acc, obj) => {
											return acc + obj.price;
										},
										0
									),
									getCurrencyUnit('EUR')
								)}
						</Text>
					</Group>
				</Box>
				<ListProjects
					type="additional"
					selectedProjects={
						offsetAdditionalProjectsSelected
					}
				/>
			</Box>
			<Box className={classes.cartBar}>
				<SelectionCart
					isLoading={isLoading}
					items={offsetMesurabilityProjectsSelected}
					size={'sm'}
					title={t('global.summary')}
					type={'summary'}
					max={offsetCreationDatas.quantity}
					onRemove={() => {}}
					handleConfirm={handleConfirmCreateOffset}
					handlechangequantity={() => {}}
					handlechangeprice={() => {}}
				/>
			</Box>
		</Box>
	);
};
